// Where each role lands after signing in: Home (/dashboard), which is shaped
// by role — reps get their day and a way into a session, managers and admins
// the team and the floor (INFORMATION_ARCHITECTURE.md §5).
export const homeFor = () => "/dashboard";
